export default {
  name: 'file.shared',
  icon: () => '/static/images/ipn/file.png',
  click ({file_id}) {
    this.$router.push(`/file/${file_id}`)
  }
}



// WEBPACK FOOTER //
// ./src/store/idonia-api/notifications/notifications/FileShared.js